import "../assets/styles/views/sign-in.scss";
import { useOutletContext, NavLink } from "react-router-dom";
import { payer_code_verify_registrazione } from "../utils/endpoints";
import { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import PasswordField from "../components/PasswordField";
import PrivacyConsent from "../components/modal-contents/PrivacyConsent";

export default function SignIn() {
  const [context, setContext] = useOutletContext();
  const [password_strength, setPasswordStrength] = useState(0);
  const [pv_selected, setPvSelected] = useState([]);
  const [customer_info, setCustomerInfo] = useState();

  const handleSubmitPlayerCode = async (e) => {
    e.preventDefault();
    const payer_code = e.target.payer_code.value;
    let response = await context.httpRequest(
      "get",
      payer_code_verify_registrazione.replace("*", payer_code)
    );

    if (!!response && !!response.data) {
      setCustomerInfo({ payer_code: payer_code, ...response.data });
    }
  };

  const handleSubmitRegister = async (e) => {
    e.preventDefault();
    let pv = [];
    if (
      !!customer_info?.puntiVendita &&
      customer_info.puntiVendita.length > 0
    ) {
      if (customer_info.puntiVendita.length < 2)
        pv = [customer_info.puntiVendita[0].codicePv];
      else {
        pv = pv_selected.map((item) => {
          return item.value;
        });
      }
    }

    const obj = {
      codiceCliente: customer_info.payer_code,
      listaCodiciPv: pv,
      firstName: e.target.name.value,
      lastName: e.target.surname.value,
      email: e.target.email.value,
      password: e.target.new_password.value,
    };

    if (obj.password !== e.target.confirm_password.value)
      context.openMessage("danger", "Le due password non corrispondono.");
    else checkPrivacy(obj);
  };

  const checkPrivacy = (obj) => {
    const is_appaltatore =
      customer_info.commissioning === "Y" &&
      customer_info.puntiVendita.filter((x) => x.codiceClasse === "COCO")
        .length > 0;

    context.openModal(
      <PrivacyConsent
        user_data={obj}
        is_appaltatore={is_appaltatore}
        context={context}
      />
    );
  };

  const handlePasswordTyping = (e) => {
    const password = e.target.value;
    let strength = 0;
    if (/[a-z]/g.test(password)) strength++;
    if (/[A-Z]/g.test(password)) strength++;
    if (/[1-9]/g.test(password)) strength++;
    if (/.{8,}/g.test(password)) strength++;

    setPasswordStrength(strength);
  };

  return (
    <section className="sign-in mt-md-5 w-100 main-panel p-3">
      <div className="d-flex align-items-center">
        <h1 className="m-0">Registrazione</h1>
        <NavLink to="/faq" className="ms-auto">
          FAQ
        </NavLink>
      </div>
      <small className="mt-3 d-block">
        Crea una nuova utenza per accedere all'applicazione
      </small>

      {customer_info == null ? (
        <form onSubmit={(e) => handleSubmitPlayerCode(e)}>
          <label className="d-block mt-3">CODICE PAYER</label>
          <input name="payer_code" type="text" className="w-100" required />
          <button className="mt-3 p-3 w-100 q8-blue-button" type="submit">
            VERIFICA
          </button>
        </form>
      ) : (
        <form
          className="secondary_step"
          onSubmit={(e) => handleSubmitRegister(e)}
        >
          {!!customer_info?.puntiVendita &&
          customer_info.puntiVendita.length > 0 ? (
            <>
              {/*FIX PASSWORD MANAGER FIREFOX*/}
              <input type="password" hidden />
              {/*FIX PASSWORD MANAGER FIREFOX*/}

              <label className="d-block mt-3">PUNTO VENDITA</label>
              {customer_info.puntiVendita.length < 2 ? (
                <select
                  style={{ backgroundColor: "#f8f8f8" }}
                  name="point_of_sale"
                  className="w-100"
                  disabled
                  required
                >
                  {customer_info.puntiVendita.map((item, index) => {
                    return (
                      <option key={index} value={item.codicePv}>
                        {`[${item.codicePv}] ${item.indirizzo}`}
                      </option>
                    );
                  })}
                </select>
              ) : (
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      border: "1px solid #cccccc",
                      borderRadius: 10,
                      padding: "0.4rem 0.8rem",
                      outline: "none",
                      marginTop: 5,
                    }),
                  }}
                  required={true}
                  closeMenuOnSelect={false}
                  components={makeAnimated()}
                  isMulti
                  onChange={(items) => setPvSelected(items)}
                  options={customer_info.puntiVendita.map((item) => {
                    return {
                      value: item.codicePv,
                      label: `[${item.codicePv}] ${item.indirizzo}`,
                    };
                  })}
                />
              )}
            </>
          ) : null}
          <label className="d-block mt-3">NOME</label>
          <input name="name" type="text" className="w-100" required />

          <label className="d-block mt-3">COGNOME</label>
          <input name="surname" type="text" className="w-100" required />

          <label className="d-block mt-3">EMAIL</label>
          <input name="email" type="email" className="w-100" required />

          <label className="d-block mt-3">PASSWORD</label>
          <PasswordField
            name="new_password"
            required={true}
            onChange={(e) => handlePasswordTyping(e)}
          />

          <div className="d-flex align-items-center mt-2">
            <small>Sicurezza password</small>
            <meter
              className="w-50 ms-auto"
              min="0"
              max="4"
              low="1"
              high="3"
              optimum="4"
              value={password_strength}
            ></meter>
          </div>
          <small className="mt-2 d-block">
            Minimo 8 caratteri, almeno un carattere maiuscolo, almeno un
            carattere minuscolo ed almeno un numero.
          </small>

          <label className="d-block mt-3">CONFERMA PASSWORD</label>
          <PasswordField name="confirm_password" required={true} />

          <button className="mt-3 p-3 w-100 q8-blue-button" type="submit">
            REGISTRATI
          </button>
        </form>
      )}
      <span className="mt-4 text-center d-block">
        Hai già un account? <NavLink to="/login">Log in</NavLink>
      </span>
    </section>
  );
}
